import React, { useState, useEffect } from 'react';

import { 
  areNotificationSoundsEnabled, 
  testNotificationSound,
  initializeAudioContext
} from '../../utils/notificationSounds';
import { useSocket } from '../../contexts/socketContext';

const NotificationSettings = () => {
  const { requestNotificationPermission, hasUserInteracted } = useSocket();
  const [soundsEnabled, setSoundsEnabled] = useState(true);
  const [browserNotificationsEnabled, setBrowserNotificationsEnabled] = useState(false);



  useEffect(() => {
    // Load current settings
    const currentSoundsEnabled = areNotificationSoundsEnabled();
    const currentBrowserEnabled = typeof Notification !== 'undefined' && Notification.permission === 'granted';
    
    setSoundsEnabled(currentSoundsEnabled);
    setBrowserNotificationsEnabled(currentBrowserEnabled);
  }, []);



  const handleBrowserNotificationToggle = async () => {
    if (typeof Notification === 'undefined') {
      return;
    }
    
    if (Notification.permission === 'granted') {
      setBrowserNotificationsEnabled(false);
      // Note: We can't programmatically revoke permission, user must do it manually
    } else {
      const granted = await requestNotificationPermission();
      setBrowserNotificationsEnabled(granted);
    }
  };







  // Get current debug info
  const getDebugInfo = () => {
    return {
      hasUserInteracted,
      soundsEnabled,
      notificationPermission: typeof Notification !== 'undefined' ? Notification.permission : 'not supported',
      storedNotifications: localStorage.getItem('unreadNotifications') || '0',
      storedMessages: localStorage.getItem('unreadMessages') || '0',
      storedSoundSetting: localStorage.getItem('notificationSoundsEnabled'),
      pendingSound: localStorage.getItem('pendingNotificationSound'),
      audioContextSupported: !!(window.AudioContext || window.webkitAudioContext),
      currentTime: new Date().toISOString()
    };
  };

  const debugInfo = getDebugInfo();







  return (
    <div className="bg-white rounded-xl p-6 shadow-lg">


      {/* Browser Notifications */}
      <div className="mb-6">
        <h4 className="text-lg font-semibold text-gray-800 mb-4">Browser Notifications</h4>
        
        <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
          <div>
            <p className="font-medium text-gray-900">Browser Notifications</p>
            <p className="text-sm text-gray-600">
              {debugInfo.notificationPermission === 'granted' 
                ? 'Notifications are enabled' 
                : debugInfo.notificationPermission === 'denied'
                ? 'Notifications are blocked - please enable in browser settings'
                : debugInfo.notificationPermission === 'not supported'
                ? 'Notifications not supported in this browser'
                : 'Click to enable browser notifications'
              }
            </p>
          </div>
          <button
            onClick={() => {
              console.log('[NOTIFICATION_SETTINGS] 🔔 Browser notification button clicked');
              handleBrowserNotificationToggle();
            }}
            disabled={debugInfo.notificationPermission === 'denied' || debugInfo.notificationPermission === 'not supported'}
            className={`px-4 py-2 text-white rounded-lg transition-colors ${
              browserNotificationsEnabled
                ? 'bg-green-500 hover:bg-green-600'
                : 'bg-blue-500 hover:bg-blue-600'
            } disabled:opacity-50 disabled:cursor-not-allowed`}
          >
            {browserNotificationsEnabled ? 'Enabled' : 'Enable'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationSettings; 